<!-- 评审管理-列表首页 -->
<template>
  <div id="expertManage">
    <!-- 页面标题 -->
    <div class="title_page">评审管理</div>
    <!-- 头部标题&按钮 -->

    <div class="opts_table">
      <el-button class="pcAddBtn" type="primary" size="small" icon="el-icon-folder-add" @click="$router.push({ path: '/edit_reviewManagement' })">创建新评审</el-button>
      <!-- 模糊查询 -->
      <el-select v-model="selected_type" multiple placeholder="选择评审类型" size="small" :popper-append-to-body="false" clearable @change="getTableData" style="width: 40%">
        <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
      </el-select>
      <el-select v-model="selected_status" multiple placeholder="选择流程状态" size="small" :popper-append-to-body="false" clearable @change="getTableData" style="width: 40%">
        <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
      </el-select>
      <el-input
        placeholder="请输入内容"
        prefix-icon="el-icon-search"
        v-model="queryParam.keyWords"
        size="small"
        clearable
        @change="getTableData"
        @keyup.enter.native="getTableData"
        style="width: 180px"></el-input>
    </div>

    <!-- 列表 -->
    <div class="table" v-loading="loading" element-loading-text="拼命加载中">
      <el-table :data="tableData" :cell-style="cellStyle" :header-cell-style="headerCellStyle" ref="table" @row-click="rowClick">
        <!-- <el-table-column prop="number" label="序号" width="60">
          <template slot-scope="props">
            <span>{{((queryParam.page-1)*queryParam.limit)+Number(props.$index+1)}}</span>
          </template>
        </el-table-column> -->
        <el-table-column
          v-for="(item, i) in tableKeys_current"
          :key="i"
          :prop="item.key"
          :label="item.title"
          :sortable="item.sortable ? 'custom' : false"
          show-overflow-tooltip
          :min-width="item.width ? item.width : ''"
          :align="item.align ?? 'center'">
          <template slot-scope="props">
            <!-- 评审流程状态特殊处理： 「已评审数量&总参与数量」对比 -->
            <div v-if="item.type == 'status' && item.key == 'status'" :class="props.row[item.key] == 2 ? (props.row.finish == props.row.count ? 'green' : 'red') : 'orange'">
              {{ item.text_status[props.row[item.key]] ? item.text_status[props.row[item.key]] : '--' }}
            </div>
            <div v-else-if="item.type == 'status'" :class="item.class_status ? item.class_status[props.row[item.key]] : ''">
              {{ item.text_status[props.row[item.key]] ? item.text_status[props.row[item.key]] : '--' }}
            </div>
            <div v-else-if="item.type == 'numCompare'" class="nowrap" :class="props.row.status == 2 ? (props.row[item.key1] == props.row[item.key2] ? 'green' : 'red') : 'orange'">
              {{ `${props.row[item.key1]}/${props.row[item.key2]}` }}
            </div>
            <div v-else-if="item.type == 'money'" class="nowrap">{{ `￥${common.formatNumber(props.row[item.key])}` }}</div>
            <div v-else-if="item.type == 'time'" class="nowrap">{{ props.row[item.key] ? moment(props.row[item.key]).format('YYYY-MM-DD HH:mm:ss') : '--' }}</div>
            <div v-else class="nowrap">{{ props.row[item.key] != null ? props.row[item.key] : '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="150" align="center">
          <template #default="scope">
            <el-button type="text" @click.stop="rowClick(scope.row)">详情</el-button>
            <el-button v-if="scope.row.status == 1" type="text" @click.stop="finishRow(scope.row)">结束流程</el-button>
          </template>
        </el-table-column>
        <div slot="empty">
          <img src="../../assets/img/emptyData.png" alt="" />
        </div>
      </el-table>
    </div>
    <div class="listIpone" v-loading="loading" element-loading-text="拼命加载中">
      <template v-if="tableData && tableData.length">
        <div class="listIBox" @click.stop="rowClick(item)" v-for="(item, index) in tableData" :key="`${index}c`">
          <div class="listIponeItem">
            <div class="left">
              <div class="tiles">
                <span class="tiltBox" :class="['tileOrruge', 'tileGreen', 'tileRed'][item.status - 1]"></span>
                评审-{{ item.number }}
              </div>
              <div class="time">
                截止时间:<span v-if="item.recordEndTime"> {{ moment(item.recordEndTime).format('YYYY.MM.DD HH:mm:ss') }}</span>
                <span v-else>暂无</span>
              </div>
              <div class="time">
                完成/参与评审企业:
                <span :class="['orange', 'green', 'red'][item.status - 1]">{{ item.finish }}/{{ item.count }}</span>
              </div>
              <div class="time">
                待分配专家数量：<span class="red">{{ item.expertCount || 0 }}</span>
              </div>
              <div class="box" :class="['DayBox', 'YearBox'][item.type - 1]">{{ ['日常评审', '年度评审'][item.type - 1] }}</div>
              <div class="distributed" v-if="item.expertCount">待分配专家</div>
            </div>
            <div class="right">
              <el-button type="text" :class="['orange', 'green', 'red'][item.status - 1]">{{ ['进行中', '已完成', '已结束'][item.status - 1] }}</el-button>
            </div>
          </div>
          <div v-if="item.status == 5">
            <div class="rowList">自评得分：</div>
            <div class="rowList">
              评审得分：{{ item.selfScore }}
              <span class="line"></span>
              设备管理成熟度：{{ item.evaluate }}
              <span class="line"></span>
              星级：{{ item.starLevel }}
            </div>
          </div>
        </div>
      </template>
      <div v-else style="text-align: center">
        <img src="../../assets/img/emptyData.png" alt="" />
      </div>
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <!--    hide-on-single-page -->
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="queryParam.page"
        :page-size="10"
        :pager-count="5"
        :layout="InnerWH.width > 450 ? 'prev, pager, next, jumper' : 'prev, pager, next'"
        :total="total">
      </el-pagination>
    </div>
    <div class="footer_btn" style="justify-content: flex-end">
      <el-button @click="$router.push({ path: '/edit_reviewManagement' })" size="small" type="primary">创建新评审</el-button>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import elUploads from '../../components/elUploads.vue';
export default {
  name: 'expertManage',
  components: { elUploads },
  data() {
    return {
      moment: moment,
      templateUrl: '', //模板下载地址
      // 列表查询传参
      queryParam: {
        keyWords: '',
        page: 1,
        limit: 10,
        type: '',
        status: '',
      },
      // 列表字段合集
      tableKeys_current: [
        // 评审流程状态status:1.评审中 2.评审结束
        { title: '评审编号', key: 'number', type: '', width: 150 },
        { title: '评审流程状态', key: 'status', type: 'status', text_status: ['', '评审中', '评审结束'], class_status: ['', 'orange', 'green'], width: 150 },
        { title: '评审类型', key: 'type', type: 'status', text_status: ['', '日常评审', '年度评审'], width: 150 },
        { title: '待分配专家数量', key: 'expertCount', width: 150 },
        { title: '完成/参与评审企业', type: 'numCompare', key1: 'finish', key2: 'count', width: 200 },
        { title: '评审截止时间', key: 'recordEndTime', type: 'time', width: 150 },
      ],
      // 列表数据
      tableData: [],
      total: 0,
      typeList: [
        { id: 1, name: '日常评审' },
        { id: 2, name: '年度评审' },
      ],
      statusList: [
        { id: 1, name: '进行中' },
        { id: 2, name: '已结束' },
      ],
      selected_type: [],
      selected_status: [],
      loading: false,
    };
  },
  computed: {
    InnerWH: function () {
      return this.$store.getters.getInnerWH;
    },
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    //获取列表数据
    getTableData() {
      let keys_param = ['type', 'status'];
      keys_param.forEach((key) => {
        this.queryParam[key] = '';
        if (this['selected_' + key].length > 0) {
          this.queryParam[key] = this['selected_' + key].join(',');
        }
      });
      this.loading = true;
      this.$axios
        .post(`${process.env.BASE_URL}api/reviewRecord/recordList`, this.queryParam)
        .then((res) => {
          if (res.data.code == 200) {
            this.tableData = res.data.page.list;
            this.total = res.data.page.totalCount;
            this.loading = false;
          } else {
            console.log(res.data.msg);
            this.loading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    // 详情
    rowClick(item) {
      this.$router.push({
        path: '/detail_reviewManagement',
        query: { id: item.id },
      });
    },
    // 列表-分页-变更当前页
    handleCurrentChange(val) {
      this.queryParam.page = val;
      this.getTableData();
    },
    // 结束评审
    finishRow(item) {
      this.$msgbox({
        title: '结束评审',
        message: '是否确定结束该评审？',
        showCancelButton: true,
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true,
        // cancelButtonClass: "cancelBtn cancelSetWidth",
        // confirmButtonClass: "uniteBtn",
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = '执行中...';
            let that = this;
            this.$axios
              .post(`${process.env.BASE_URL}api/reviewRecord/deleteRecord`, { id: item.id })
              .then((res) => {
                if (res.data.code == 200) {
                  let totalPage = Math.ceil((that.total - 1) / that.queryParam.limit);
                  let current = that.queryParam.page > totalPage ? totalPage : that.queryParam.page;
                  that.queryParam.page = current < 1 ? 1 : current;
                  that.getTableData();
                  that.$message({
                    message: '已结束',
                    type: 'success',
                  });
                } else {
                  that.$message({
                    message: res.data.msg,
                    type: 'error',
                  });
                }
                //确认弹窗还原&关闭
                instance.confirmButtonText = '确定';
                instance.confirmButtonLoading = false;
                done();
              })
              .catch(() => {
                //确认弹窗还原&关闭
                instance.confirmButtonText = '确定';
                instance.confirmButtonLoading = false;
                done();
              });
          } else {
            //确认弹窗还原&关闭
            instance.confirmButtonText = '确定';
            instance.confirmButtonLoading = false;
            done();
          }
        },
      })
        .then((action) => {})
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
            offset: 100,
          });
        });
    },
    // 列表-表头样式
    headerCellStyle(header) {
      if (header.column.order == 'ascending' || header.column.order == 'descending') {
        return { color: '#3D7BDC', fontSize: '14px', fontWeight: 400 };
      } else {
        return { color: '#617180', fontSize: '14px', fontWeight: 400 };
      }
    },
    // 列表-单元格样式
    cellStyle() {
      return {
        fontSize: '14px',
        color: '#111928',
        fontWeight: 500,
        padding: '8px 0px',
      };
    },
  },
};
</script>
<style lang="less" scoped>
.opts_table {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 10px;
  .el-select,
  .el-input {
    margin: 0px 5px;
  }
}

.btns_tab {
  width: 265px;
  display: flex;
  margin-top: 23px;
  margin-bottom: 17px;
  padding: 4px;
  font-weight: 500;
  border-radius: var(--rounded-md, 6px);
  border: 1px solid rgba(229, 231, 235, 0.8);
  background: var(--gray-100, #f3f4f6);
  div {
    width: 50%;
    text-align: center;
    cursor: pointer;
    line-height: 150%;
    padding: 4px;
  }
  .active {
    border-radius: var(--rounded-md, 6px);
    background: var(--gray-700, #374151);
    color: #ffffff;
  }
}
.listIpone {
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  border: 1px solid #ebecf1;
  background: #fbfdff;
  padding: 15px;
  .listIBox {
    margin-bottom: 20px;
  }
  .listIponeItem {
    display: flex;
    align-items: center;
    // margin-bottom: 4px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebecf1;
    // cursor: pointer;
    position: relative;
    .left {
      .tiles {
        color: #4f5d77;
        font-size: 18px;
        font-weight: 500;
        margin-bottom: 4px;
        display: flex;
        align-items: center;
        .tiltBox {
          width: 6px;
          height: 6px;
          margin-right: 8px;
          display: inline-block;
        }
        .tileOrruge {
          background: #f68e6d;
        }
        .tileRed {
          background: #df5151;
        }
        .tileBlue {
          background: #499bde;
        }
        .tileGreen {
          background: #5b9f7b;
        }
      }
      .time {
        color: rgba(79, 93, 119, 0.6);
        line-height: 28px;
        span {
          color: #4f5d77;
          font-size: 14px;
          font-weight: 500;
          letter-spacing: 0.01px;
        }
      }
      .box {
        width: 76px;
        height: 25px;
        text-align: center;
        line-height: 25px;
        border-radius: 18px;
        font-size: 12px;
        margin-top: 4px;
      }
      .DayBox {
        border-radius: 18px;
        background: rgba(79, 93, 119, 0.16);
        color: rgba(79, 93, 119, 0.7);
      }
      .YearBox {
        border-radius: 18px;
        background: rgba(62, 123, 250, 0.16);
        color: rgba(62, 123, 250, 0.7);
      }
    }
    .right {
      margin-left: auto;
    }
    .distributed {
      position: absolute;
      right: 0;
      top: 0;
      background-color: #df5151;
      color: #ebecf1;
      border-radius: 18px;
      font-size: 12px;
      padding: 4px 8px;
    }
  }
  .rowList {
    color: rgba(79, 93, 119, 0.6);
    font-size: 14px;
    line-height: 25px;
  }
}
</style>
<style lang="less" scoped>
/* PC端样式 */
@media only screen and (min-width: calc(700px + 1px)) {
  .table,
  .pcAddBtn {
    display: block;
  }
  .footer_btn,
  .listIpone {
    display: none;
  }
}

/* 移动端样式 */
@media only screen and (max-width: 700px) {
  .table,
  .pcAddBtn {
    display: none;
  }
  .footer_btn,
  .listIpone {
    display: flex;
  }
}
</style>
